import { createContext, useContext, type ReactNode } from 'react';

const FormBusyContext = createContext(false);

/**
 * When `busy` is true:
 * - FormField / FormikRangeSlider set `disabled`
 * - nested native controls (buttons, inputs) are disabled via <fieldset disabled>
 */
export const FormBusyProvider = ({ busy, children }: { busy: boolean; children: ReactNode }) => (
    <FormBusyContext.Provider value={busy}>
        <fieldset disabled={busy} aria-busy={busy || undefined}>
            {children}
        </fieldset>
    </FormBusyContext.Provider>
);

export const useFormBusy = (): boolean => useContext(FormBusyContext);
